<template>
  <p class="flex mb10">
    <span>{{ pre }}</span>
    <el-input size="mini" class="w60" :class="inputClass" v-model="val"></el-input>
    <span>{{ suf }}</span>
  </p>
</template>

<script>
export default {
  name: "staff-input",
  props: {
    value: [String, Number],
    pre: {
      type: String,
      default: ''
    },
    suf: String,
    max: Number,
    min: Number,
    length: Number,
    float: Number,
    inputClass: [String]
  },
  data() {
    return {
      val: ''
    }
  },
  watch: {
    value(newV) {
      this.val = newV;
    },
    val(newV) {
      const {max, min, length, float} = this;
      Log('newV', newV);
      if (newV === '' || newV === undefined) return;
      if (typeof max === 'number') {
        if (newV > max) {
          newV = max;
          this.val = max;
          this.$message.error('最大值为' + max);
        }
      }
      if (typeof min === 'number') {
        if (newV < min) {
          newV = min;
          this.val = min;
          this.$message.error('最小值为' + min);
        }
      }
      if (typeof length === "number") {
        if (newV.length > length) {
          this.$message.error('长度不能超过' + length);
        }
      }
      if (typeof float === 'number' && parseFloat(newV)) {
        newV = '' + newV;
        let idx = newV.indexOf('.');
        if (idx >= 0) {
          let len = newV.substr(idx + 1);
          if (len.length > float) {
            Log('idx', idx, len.length);
            this.val = parseFloat(newV).toFixed(float);
            newV = this.val;
          }
        }
      }
      this.$emit('input', newV)
    }
  },
  created() {
    this.val = this.value
  }
}
</script>

<style scoped>

</style>